
import { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { supabase } from '../lib/supabase'

export function EmployeeJoin() {
  const navigate = useNavigate()
  const location = useLocation()
  const code = new URLSearchParams(location.search).get('code') || ''
  const [error, setError] = useState('')

  useEffect(() => {
    let alive = true

    async function join() {
      if (!supabase || !code) {
        if (alive) setError('Workspace code is missing.')
        return
      }

      const { data: { user } } = await supabase.auth.getUser()
      if (!user) {
        navigate(`/login?employeeCode=${encodeURIComponent(code)}`, { replace: true })
        return
      }

      const displayName = String(user.user_metadata?.full_name ?? '').trim() || null
      const { error: joinError } = await supabase.rpc('join_organisation_by_code', {
        p_code: code,
        p_display_name: displayName
      })

      if (!alive) return

      if (joinError) {
        setError(joinError.message)
        return
      }

      navigate('/employee', { replace: true })
    }

    join()
    return () => { alive = false }
  }, [code, navigate])

  return <div className="auth-loading">
    {error ? <div className="auth-card"><h1>Could not join workspace</h1><p className="auth-error">{error}</p></div> : <span className="blue-spinner auth-spinner"/>}
  </div>
}
